// cache.interceptor.ts (Functional version)
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of, tap } from 'rxjs';
import { CacheService } from '../services/cache.service';

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
    const cacheService = inject(CacheService);

    if (req.method !== 'GET') return next(req);

    const cached = cacheService.get(req.urlWithParams);
    if (cached) return of(cached.clone());

    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
                cacheService.set(req.urlWithParams, event.clone());
            }
        })
    );
};
